import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils'

export const getCalendar = createAsyncThunk('calendar/getCalendar',
	async ({dateMeta, venueMeta}: CalendarQuery) => {
		const url = `v1/calendar-items${serializeQueryParam({venueId: venueMeta, date: dateMeta})}`
		const response: AxiosResponse<CalendarState[]> = await instance.get(url)
		return response.data
	})


